import { Component } from "react";
import "@/App.css";

class ErrorBoundary extends Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cream px-8 text-center font-sans text-ink">
                    <p className="font-display text-2xl">
                        Something derailed along the journey.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="rounded-full bg-terracotta px-6 py-2.5 text-sm font-semibold text-cream"
                    >
                        Reload
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
